import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ConfigService} from './config.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService
    ) {
    }

    public refresh(payload: { refreshToken: string }): Observable<any> {
        return this.httpClient.post(`${this.configService.config.SECRET_HANDLER_REFRESH}`, {
            refresh: payload.refreshToken
        });
    }

    public logout(token: string): Observable<any> {
        return this.httpClient.get(`${this.configService.config.AMAIA_BASE_URL}/api/user/logout`, {
            headers: new HttpHeaders({
                Authorization: `Bearer ${token}`,
            })
        });
    }

    public getUser(token: string): Observable<any> {
        return this.httpClient.get(`${this.configService.config.AMAIA_BASE_URL}/api/user`, {
            headers: new HttpHeaders({
                Authorization: `Bearer ${token}`,
            })
        });
    }

    public login(payload: { authorization: string }): Observable<any> {
        return this.httpClient.post(`${this.configService.config.SECRET_HANDLER}`, {
            authorization: payload.authorization
        });
    }
}
